import { Component, signal } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { HeaderComponent } from './shared/components-generals/header/header.component';

const APP_ICONS = [
  'icon_home',
  'icon_mapa',
  'icon_perfil',
  'logo-general-blanco',
  'logo-general',
  'icon_carrito',
  'logo_ei_azul',
  'logo_holanda',
  'icon_corazon',
  'icon_repartidor_verde',
] as const;

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent],
  templateUrl: './app.html',
})
export class App {
  protected readonly title = signal('MagnumEiDelivery');
  protected isLoggedIn = false;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private router: Router,
  ) {
    APP_ICONS.forEach((iconName) => {
      this.iconRegistry.addSvgIcon(
        iconName,
        this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${iconName}.svg`),
      );
    });

    this.translate.setDefaultLang('es');
    this.translate.use('es');

    this.updateLoginState(this.router.url);
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.updateLoginState(event.urlAfterRedirects);
      });
  }

  private updateLoginState(url: string) {
    const currentPath = url.split('?')[0].split('#')[0];
    this.isLoggedIn = currentPath !== '/login';
  }
}
